<template lang="pug">
section.single
  Header
  .container
  Footer
</template>

<script>
const page = {
  id: 'contact',
  title: 'コンタクト'
}

export default {
  name: page.id,
  data () {
    return {
      mask: false,
      app: {
        name: process.env.VUE_APP_NAME
      },
      page: page
    }
  },
  async created () {
    window.location.href = process.env.VUE_APP_CONTACT_URL
  },
  methods: {
  }
}
</script>

<style scoped lang="stylus">
</style>
